<template>
  <hr
    :aria-orientation="vertical?'vertical':'horizontal'"
    :class="classList"
    :style="styleList"
  >
</template>

<script lang="ts">
  import colorable from '../../mixins/colorable/colorable';
  import mixins from '../../mixins';

  export default mixins(colorable).extend({
    mixins: [colorable],
    props: {
      color: { type: String, default: 'app-1' },
      vertical: { type: Boolean, default: false },
    },
    computed: {
      classList(): Record<string, boolean> {
        return {
          'p-divider': true,
          vertical: this.vertical,
          ...this.getBorderColor().class,
        };
      },
      styleList(): Record<string, string> {
        return {
          ...this.getBorderColor().style,
        };
      },
    },
  });
</script>
